import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles } from '@/mocks/articles';

const articlesListSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '健康资讯 - 新有菜',
  description: '阅读新有菜最新健康资讯，包括选菜指南、时令推荐、保鲜技巧、创意料理等蔬菜相关文章。',
  url: 'https://www.xinyoucai.com/articles',
};

export default function ArticlesPage() {
  return (
    <Layout>
      <SEO
        title="健康资讯 - 新有菜 | 蔬菜选购、保鲜与烹饪指南"
        description="阅读新有菜最新健康资讯，包括蔬菜选购技巧、时令蔬菜推荐、保鲜方法、创意料理食谱等实用内容，让您吃得更健康。"
        keywords="蔬菜资讯,蔬菜选购,保鲜技巧,时令蔬菜,蔬菜食谱,健康饮食"
        canonicalUrl="/articles"
        schema={[articlesListSchema]}
      />

      <div className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '健康资讯' },
            ]}
          />

          <div className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              健康资讯
            </h2>
            <p className="text-sm text-foreground-500">
              蔬菜选购、保鲜、烹饪全攻略，让健康饮食更简单
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article, index) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                style={{ animation: `slideUp 400ms ease-out ${index * 80}ms both` }}
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-2.5 py-0.5 bg-primary-50 text-primary-700 text-xs font-medium rounded-full">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center">
                        <i className="ri-user-line text-xs text-secondary-600"></i>
                      </div>
                      <span className="text-xs text-foreground-400">{article.author}</span>
                    </div>
                    <span className="text-xs text-foreground-300">{article.publishDate}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}